var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Suspense, useEffect, useState } from "react";
import { ContentState, convertFromRaw, convertToRaw, EditorState, } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./plainEditor.css";
import { Editor } from "./Editor";
import { useUpdateEffect } from "../../../hooks/useUpdateEffect";
import { keywords } from "./DTKeywords";
import { TemplatePool, } from "../../../../../server/sharedScripts/templates";
import ImageComponent from "./ImageComponent";
import classNames from "classnames";
export default function PlainEditor(props) {
    var _a;
    const { disableExtraSpacing } = props;
    const [focused, setFocused] = useState(false);
    const isEditable = props.editable == undefined || props.editable == true ? true : false;
    const [editorValue, setEditorValue] = useState(EditorState.createWithContent(ContentState.createFromText("")));
    useEffect(() => {
        try {
            if (props.example.length != 0) {
                convertFromRaw(JSON.parse(props.example));
            }
            setEditorValue(EditorState.createWithContent(props.example.length == 0 ?
                ContentState.createFromText("")
                : convertFromRaw(JSON.parse(props.example))));
        }
        catch (err) {
            if (!(err instanceof SyntaxError)) {
                console.error(err);
            }
        }
    }, [props.update]);
    useUpdateEffect(() => {
        props.onChange(convertToRaw(editorValue.getCurrentContent()));
    }, [editorValue]);
    if (!isEditable) {
        return (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null, "...") },
            React.createElement(Editor, { editorState: editorValue, readOnly: true, toolbarHidden: true, editorClassName: "editor-padding", wrapperClassName: "editor-wrapper-readonly" })));
    }
    const pool = !props.suggestionsPool ?
        []
        : Object.entries(TemplatePool[props.suggestionsPool]).map(([_, { tag }]) => ({
            text: tag,
            value: tag,
        }));
    return (React.createElement("label", { className: classNames({
            "input-label plain-editor-label": !props.withoutLabel,
            "no-spacing": disableExtraSpacing,
        }), style: {
            width: props.fullWidth ? "100%" : "",
        } },
        props.label,
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null, "...") },
            React.createElement(Editor, { handlePastedText: () => false, wrapperClassName: "editor-wrapper", editorClassName: "editor-plain-area editor-padding" +
                    (focused ? " editor-plain-area-focus" : ""), onFocus: () => setFocused(true), mention: {
                    separator: " ",
                    trigger: "#",
                    suggestions: [
                        ...((_a = props.suggestions) !== null && _a !== void 0 ? _a : []),
                        ...(props.supportsDT ? keywords : []),
                        ...pool,
                    ],
                }, onBlur: () => {
                    var _a;
                    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, convertToRaw(editorValue.getCurrentContent()));
                    setFocused(false);
                }, editorState: editorValue, onEditorStateChange: setEditorValue, readOnly: false, toolbar: {
                    textAlign: {
                        inDropdown: false,
                        options: ["center", "left", "right"],
                    },
                    image: {
                        urlEnabled: true,
                        uploadEnabled: false,
                        component: ImageComponent,
                        uploadCallback: (file) => __awaiter(this, void 0, void 0, function* () {
                            const src = URL.createObjectURL(file);
                            return {
                                data: {
                                    link: src,
                                },
                            };
                        }),
                        previewImage: false,
                        inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                        alignmentEnabled: true,
                    },
                    fontFamily: {
                        className: "rdw-font-family-selector",
                    },
                    inline: {
                        options: [
                            "bold",
                            "italic",
                            "underline",
                            "strikethrough",
                            "superscript",
                            "subscript",
                        ],
                    },
                    list: {
                        options: ["unordered", "ordered"],
                    },
                }, localization: {
                    locale: "pl",
                } }))));
}
